<div class="described-extent row no-gutters align-items-stretch position-relative">
  <button type="button" class="btn btn-default open-btn" (click)="openMap()" *ngIf="isEditable">
    <ng-container i18n>Choisir les emprises</ng-container>
  </button>
  <simple-map class="w-100" [extents]="extents"></simple-map>
</div>